<script>
  import Navigation from "../components/UI/Navigation.svelte";

  export let title;
  export let subtitle = "";
</script>

<style>
  header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 3rem;
  }
  @media screen and (min-width: 900px) {
    header {
      height: 100vh;
      position: sticky;
      position: -webkit-sticky;
      top: 0px;
    }
  }
  .title-container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 4rem;
  }
  .subtitle {
    color: var(--color-theme-4);
    font-weight: 400;
    text-align: center;
    margin-bottom: 3rem;
  }
</style>

<div class="container">
  <div class="row">
    <header class="col-12 col-6-md col-6-lg header">
      <Navigation />
      <div class="title-container">
        <h1 class="title">{title}</h1>
        {#if subtitle}
          <p class="subtitle">{subtitle}</p>
        {/if}
        <slot name="subnav" />
      </div>
    </header>
    <div class="col-12 col-6-md col-6-lg">
      <slot />
    </div>
  </div>
</div>
